@if (toggleCategory) {
  <div class="container_menu_category">
    <ul>
      <li>
        <a [routerLink]="['category', 'artoys']" aria-label="Category" placement="top" (click)="scroll()"> Art Toy </a>
      </li>
      <li>
        <a [routerLink]="['category', 'sofubi']" aria-label="Category" placement="top" (click)="scroll()"> Sofubi </a>
      </li>
      <li>
        <a [routerLink]="['category', 'gachapon']" aria-label="Category" placement="top" (click)="scroll()"> Gachapon </a>
      </li>
      <li>
        <a [routerLink]="['category', 'blindbox']" aria-label="Category" placement="top" (click)="scroll()"> Blinbox </a>
      </li>
    </ul>
  </div>
}

@if (load) {
  <div class="container__menu">
    <ul class="m-0 p-0">
      <li>
        <!-- <a [routerLink]="[ '/' ]"><img src="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/e_solo.webp"
                        class="menu-logo" alt="logo_etoyrepublic"></a> -->
        <a [routerLink]="['/']" aria-label="Home" (click)="scroll()" placement="top" ngbTooltip="Home">
          <fa-icon [icon]="['fas', 'home']" size="lg"></fa-icon>
          <!-- <img src="./assets/img/e_only_white_mini.webp" class="menu-logo" alt="logo_etoyrepublic" placement="top" ngbTooltip="Home" width="30" height="28" /> -->
        </a>
      </li>

      <li>
        @if (auth() === true) {
          <a [routerLink]="['account', 'orders']" aria-label="User Account" placement="top" ngbTooltip="Account" (click)="scroll()">
            <fa-icon [icon]="['fajr', 'circle-user']" size="xl"></fa-icon>
          </a>
        }
        @if (auth() === false) {
          <a [routerLink]="['login']" aria-label="Log in" placement="top" ngbTooltip="Login" (click)="scroll()">
            <fa-icon [icon]="['fajr', 'circle-user']" size="xl"></fa-icon>
          </a>
        }
      </li>

      <li class="cursor-pointer">
        <fa-icon [icon]="['fajr', 'layer-group']" size="lg" class="category_menu" placement="top" ngbTooltip="Categorias" (click)="toggle()"></fa-icon>
      </li>
      <li class="cursor-pointer">
        <app-cart placement="top" [ngbTooltip]="'Cart ' + list" />
      </li>
    </ul>
  </div>
}
